<script>
    import UIModulePart from "./modules.part.svelte";

    export let value = [];
    export let picture;
    export let picWidth;
    export let picHeight;
</script>

<div class="module-calc-picture-modules">
    {#if value}
        {#each value as moduleValue}
            <UIModulePart {...moduleValue} {picture} {picWidth} {picHeight}
            ></UIModulePart>
        {/each}
    {/if}
</div>
